export default __webpack_public_path__ + "static/media/logout.41fe8887.svg";